import { PocSwitch } from 'commons/components/components-wrapper/poc-switch.component';
import { HeaderOptionsContainer } from 'modules/settings/components/settings-table-header-options/settings-table-header-options.style';

interface SettingsTableHeaderOptionsComponentProps {
    showOnlyActive: boolean;
    onShowOnlyActiveChange: (showOnlyActive: boolean) => void;
    text: string;
}

export const SettingsTableHeaderOptionsComponent: React.FC<SettingsTableHeaderOptionsComponentProps> = ({
    showOnlyActive,
    onShowOnlyActiveChange,
    text,
}) => (
    <HeaderOptionsContainer>
        <PocSwitch checked={!showOnlyActive} onValueChange={() => onShowOnlyActiveChange(!showOnlyActive)} />
        <span>{text}</span>
    </HeaderOptionsContainer>
);
